import * as yup from "yup";
import { useForm } from "react-weaver";

import { identity } from "../utils/functional";

interface AddressFormValues {
  streetLine: string;
  suburb: string;
  state: string;
  postcode: string;
  unit?: string;
}

interface UseManualAddressFormArgs {
  initialValues: AddressFormValues;
  onChange?: (value: AddressFormValues & { isManual: boolean }) => void;
  onError?: (error: any) => void;
}

// TODO add and make types work here
// interface UseManualAddressFormReturn {
//   fieldProps: {
//     [key in keyof AddressFormValues]: any; // Specify more detailed type if available
//   };
//   errors: {
//     [key in keyof AddressFormValues]?: string;
//   };
// }

export function useManualAddressForm(
  {
    initialValues,
    onChange = identity,
    onError = identity,
  }: UseManualAddressFormArgs = {} as UseManualAddressFormArgs
) {
  const handleChange = (value: AddressFormValues) => {
    onChange({
      ...value,
      isManual: true,
    });
  };

  return useForm({
    initialValues,
    validator: yup.object().shape({
      streetLine: yup
        .string()
        .test(
          "check-street-no",
          "Your address must include a street number.",
          function (value) {
            return /\d/.test(value ?? "");
          }
        )
        .required()
        .label("Street line"),
      suburb: yup.string().required().label("Suburb"),
      state: yup.string().required().label("State"),
      postcode: yup.string().required().label("Postcode"),
    }),
    onChange: handleChange,
    onError,
  });
}
